// src/components/reports/precon-report-builder/sub-letter.ts

/**
 * Bijective base-26 sub-letter for a 0-based index:
 * `0→a … 25→z, 26→aa, 27→ab … 701→zz, 702→aaa`.
 *
 * Used to label the photos of a single record under its one numbered pin —
 * a multi-photo record renders `Na, Nb, Nc…` (and `U#a, U#b…` when not
 * located), in `taken_at` order. "Bijective" (no zero digit) is what makes it
 * roll `z → aa` instead of `z → ba`, so every index maps to a unique label and
 * a record with more than 26 photos still reads cleanly.
 */
export function subLetter(index: number): string {
  // Callers always pass non-negative map indices (0-based photo position within
  // a record). Negative input would loop indefinitely — guard at call sites.
  let n = index;
  let out = "";
  do {
    out = String.fromCharCode(97 + (n % 26)) + out;
    n = Math.floor(n / 26) - 1;
  } while (n >= 0);
  return out;
}
